import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/components/skeletonLoaders/constants';

export const AuthorNameSkeleton = () => (
  <ContentLoader height={20} viewBox="0 0 150 20" {...DEFAULT_SETTINGS}>
    <rect x="0" y="0" rx="0" ry="0" width="150" height="20" />
  </ContentLoader>
);
